import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import * as motion from "motion/react-client"
import { PerformAssessmentStyles, Step1Styles } from './Style'
import { Img } from 'styles/GlobalStyle'
import { Butterfly3, Butterfly2, Butterfly1, Sun, EndPath, Like } from 'assets'
import { AbilityContext, Can } from 'components/Permissions/Can'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { app } from 'router/routes'
import { AnimatePresence } from "motion/react"
import { IconButton } from '@mui/material'
import { Pause, PlayArrow } from '@mui/icons-material'
import { useSelector } from 'react-redux'
import { screen_5_finish_message_male, screen_5_finish_message_female, screen_1_short_introduction_male, screen_1_short_introduction_female, screen_1_introduction_male, screen_1_introduction_female } from 'introductions'
import NextButton from './NextButton'
import ReactPlayer from 'react-player';
import { performAssessmentHooks, RatingList } from '.'
import { map, takeRight } from 'lodash'

const CompleteScreen = () => {
    const { testTaker = {} } = useSelector(state => state.testTaker)
    const [cartoonSpeaking, setCartoonSpeaking] = useState(true)
    const [shouldAnimate, setShouldAnimate] = useState(false);
    const navigate = useNavigate()

    const ability = useContext(AbilityContext)
    const { state } = useLocation()
    const { totalAssessmentsCount, isMaleGender, isHighGrade, basePath } = state || {}

    const testTakerRef = useRef(testTaker);

    const ratings = performAssessmentHooks.useRatings()
    const ratings2 = map(ratings)
    const assessmentRatings = takeRight(ratings2, totalAssessmentsCount)

    const item = {
        path: EndPath,
        cartoonGif: Like,
        cartoon: Like,
        marginRight: 900,
        width: 1000,
        height: 300,
        audio: isMaleGender ? screen_5_finish_message_male : screen_5_finish_message_female,
        hidePlayPause: true,
        autoNextStep: true,
        finish: true
    }

    const handleCartoonSpeaking = useCallback(() => {
        setCartoonSpeaking(cartoonSpeaking => !cartoonSpeaking)
    }, [])

    const goNextStep = useCallback(() => {
        setCartoonSpeaking(false)
        setShouldAnimate(true);
        setTimeout(() => {
            // אחרי סיום הביצוע לחזור לדשבורד - באם אתה תלמיד
            if (ability.can("manage", "student"))
                navigate(app.dashboard)
            else
                navigate(basePath)
        }, 1500);
    }, [])

    const onEndedPlayer = useCallback(() => {
        goNextStep()
    }, [item])

    useEffect(() => {
        testTakerRef.current = testTaker
    }, [testTaker])

    useEffect(() => {
        let timer
        if (isHighGrade)
            timer = setTimeout(goNextStep, 5500);
        return () => clearTimeout(timer);
    }, [isHighGrade])

    if (!state) {
        return <Navigate to={app.performAssessments} replace />;
    }

    return (
        <PerformAssessmentStyles>
            <AnimatePresence mode="wait">

                <div className='ratings-complete-screen'>
                    <RatingList ratings={assessmentRatings} />
                </div>

                <Step1Styles pathWidth={item.width} pathHeight={item.height} cartoonMarginRight={item.marginRight}>

                    <React.Fragment>
                        <div className='wrap-sun'>
                            {!shouldAnimate ? (
                                <motion.div
                                    exit={{ opacity: 0 }}
                                    initial={{ opacity: 0 }}
                                    animate={shouldAnimate ? { opacity: 0 } : { opacity: 1 }} // אם shouldAnimate true, מתחילים להיעלם
                                    transition={{ duration: 0.7 }}
                                    className='sun'
                                    key="box"
                                >
                                    <div className='sun'>
                                        <Img src={Sun} />
                                    </div>
                                </motion.div>)
                                : null}
                        </div>
                        {!shouldAnimate ? (
                            <motion.div
                                exit={{ opacity: 0 }}
                                initial={{ opacity: 0 }}
                                animate={shouldAnimate ? { opacity: 0 } : { opacity: 1 }} // אם shouldAnimate true, מתחילים להיעלם
                                transition={{ duration: 0.7 }}
                                className='butterfly1'
                                key="butterfly1"
                            >
                                <Img src={Butterfly1} />
                            </motion.div>) : null}
                        {!shouldAnimate ? (
                            <motion.div
                                exit={{ opacity: 0 }}
                                initial={{ opacity: 0 }}
                                animate={shouldAnimate ? { opacity: 0 } : { opacity: 1 }} // אם shouldAnimate true, מתחילים להיעלם
                                transition={{ duration: 0.7 }}
                                className='butterfly2'
                                key="butterfly2"
                            >
                                <Img src={Butterfly2} />
                            </motion.div>) : null}
                        {!shouldAnimate ? (
                            <motion.div
                                exit={{ opacity: 0 }}
                                initial={{ opacity: 0 }}
                                animate={shouldAnimate ? { opacity: 0 } : { opacity: 1 }} // אם shouldAnimate true, מתחילים להיעלם
                                transition={{ duration: 0.7 }}
                                className='butterfly3'
                                key="butterfly3"
                            >
                                <Img src={Butterfly3} />
                            </motion.div>) : null}
                        {!shouldAnimate ? (
                            <motion.div
                                exit={{ opacity: 0 }}
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ duration: 0.7 }}
                                className='path-img'
                                key="box"
                            >
                                <Img src={item.path} />
                            </motion.div>) : null}
                        {!shouldAnimate ? (
                            <div className='wrap-cartoon-img'>
                                <motion.div
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.7 }}
                                    className='cartoon-img'
                                >
                                    <Img src={cartoonSpeaking ? item.cartoonGif : item.cartoon} />
                                    {item.hidePlayPause ||
                                        <div className='play-pause-cartoon'>
                                            <IconButton onClick={handleCartoonSpeaking}>
                                                {cartoonSpeaking ? <Pause color="thirdly" /> : <PlayArrow color="thirdly" />}
                                            </IconButton>
                                        </div>}
                                </motion.div>
                            </div>) : null}
                        <Can I="manage" a="super-user">
                            {!shouldAnimate ? (
                                <motion.div
                                    exit={{ opacity: 0 }}
                                    initial={{ opacity: 0 }}
                                    animate={shouldAnimate ? { opacity: 0 } : { opacity: 1 }} // אם shouldAnimate true, מתחילים להיעלם
                                    transition={{ duration: 0.7 }}
                                >
                                    <div className='wrap-fab-button'>
                                        <NextButton finish={item.finish} action={goNextStep} />
                                    </div>
                                </motion.div>) : null}
                        </Can>
                        <ReactPlayer
                            playing={
                                !isHighGrade &&
                                cartoonSpeaking}
                            url={item.audio}
                            controls={true}
                            width='0px' height='0px'
                            onEnded={onEndedPlayer}
                        />
                    </React.Fragment>
                </Step1Styles>
            </AnimatePresence>
        </PerformAssessmentStyles >
    )
}

export default CompleteScreen
